import template from './vehicles.html';
import controller from './vehicles.controller';

let vehiclesComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default vehiclesComponent;
